export const recordIntent = options => {
  const { productArr, csrf } = options;
  return fetch('/merchantapps/api/v1/recordIntent', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(productArr),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf
    }
  });
};

export const productToRPSMapping = {
  pp_subscriptions_v1: 'subscriptionsHawk',
  pp_here: 'pph',
  pp_me: 'ppme',
  pp_invoicing: 'invoicingHawk',
  pp_virtual_terminal: 'vt',
  pp_store_cash: 'ppShopping',
  pp_shopper_insights: 'ppInsights',
  pp_checkout: 'spbSdk',
  pp_buttons: 'spbButton',
  pp_digital_giftcard: 'ppdg',
  qr_code: 'qrcode',
  pp_izettle: 'izettle'
};

export const ADD_DEV_RPS = 'spbDev';

export const divIdNumToRPSMap = {
  '1': 'spbButton',
  '2': 'spbSdk',
  '3': 'ucc'
};
